import React from "react";
import { Toolbar } from "react-admin";
import { SaveWithAreYouSureButton } from "../button/SaveWithAreYouSureButton";

const SaveOnlyToolbar = (props) => {
  return (
    <Toolbar {...props}>
      <SaveWithAreYouSureButton
        {...props}
        disabled={!!(props.saving || props.invalid || props.pristine)}
      />
    </Toolbar>
  );
};

export default SaveOnlyToolbar;
